import { AuditTrail } from '@/features/audit/ui/AuditTrail';

/**
 * §5: a page composes, it does not implement.
 */
export function AuditPage() {
  return <AuditTrail />;
}
